import { render, staticRenderFns } from "./Pagos.vue?vue&type=template&id=64006008&scoped=true&"
import script from "./Pagos.vue?vue&type=script&lang=js&"
export * from "./Pagos.vue?vue&type=script&lang=js&"
import style0 from "./Pagos.vue?vue&type=style&index=0&id=64006008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64006008",
  null
  
)

export default component.exports